import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function Protected({ children, requireRole }) {
    const { user, loading } = useAuth();
    const location = useLocation();
    if (loading) return (
        <div className="min-h-screen flex items-center justify-center bg-background text-muted-foreground text-sm">
            <div className="flex items-center gap-3">
                <div className="w-2 h-2 bg-primary animate-pulse"></div>
                Loading workspace…
            </div>
        </div>
    );
    if (!user) {
        // Preserve the current URL so login can redirect back to it.
        const next = encodeURIComponent(location.pathname + location.search);
        return <Navigate to={`/login?next=${next}`} replace />;
    }
    if (requireRole === "super_admin" && user.role !== "super_admin") return <Navigate to="/app" replace />;
    if (requireRole === "tenant") {
        if (user.role === "super_admin") return <Navigate to="/admin" replace />;
        if (user.role === "client_portal") return <Navigate to="/portal" replace />;
        if (user.role === "partner") return <Navigate to="/partner" replace />;
        if (!user.tenant_id) return <Navigate to="/admin" replace />;
    }
    if (requireRole === "portal" && user.role !== "client_portal") {
        return <Navigate to={user.role === "super_admin" ? "/admin" : "/app"} replace />;
    }
    return children;
}
